import React from 'react';
import { Box, Typography, Stack, Chip } from '@mui/material';
import { WriteoffApprovalView } from '../../../../../../services/WriteoffService/types/writeoffTypes';
import { getCurrentStatus, getStatusColor, formatCurrency } from '../constants';

interface ApprovalDetailsSectionProps {
  approval: WriteoffApprovalView;
  writeoffAmount: number;
}

export const ApprovalDetailsSection: React.FC<ApprovalDetailsSectionProps> = ({
  approval,
  writeoffAmount,
}) => {
  const status = getCurrentStatus(approval);

  return (
    <Box>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Approval Level Details
      </Typography>
      <Stack spacing={1}>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body2">Level:</Typography>
          <Chip label={approval.level} size="small" color="primary" variant="outlined" />
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body2">Current Status:</Typography>
          <Chip label={status} size="small" color={getStatusColor(status)} variant="filled" />
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body2">Writeoff Amount:</Typography>
          <Typography variant="body2" fontWeight="medium">
            {formatCurrency(writeoffAmount)}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body2">Threshold:</Typography>
          <Typography variant="body2">
            {formatCurrency(approval.minAmount)}
            {approval.maxAmount && ` - ${formatCurrency(approval.maxAmount)}`}
          </Typography>
        </Box>
        {approval.approvedDate && (
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2">Approved Date:</Typography>
            <Typography variant="body2">
              {new Date(approval.approvedDate).toLocaleDateString()}
            </Typography>
          </Box>
        )}
        {approval.rejectedDate && (
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2">Rejected Date:</Typography>
            <Typography variant="body2">
              {new Date(approval.rejectedDate).toLocaleDateString()}
            </Typography>
          </Box>
        )}
      </Stack>
    </Box>
  );
};

export default ApprovalDetailsSection;
